import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  fetchPreferenceFailure,
  fetchPreferenceSuccess,
} from "../slices/features/preference";
import { RequestTypes } from "../types";
import { LocalStorageService } from "src/services/local-storage";

const appservice = new AppService();
const localStorageService = new LocalStorageService();

function* fetchPreferenceSaga(action: any) {
  const { payload } = action;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.fetchPreference,
      baseUrl
    );

    if (response?.data) {
      yield call(
        localStorageService.persist,
        "preferences",
        JSON.stringify(response?.data)
      );
    }

    yield put(fetchPreferenceSuccess({ ...response }));

    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(fetchPreferenceFailure({ statusCode, statusText }));
  }
}

export function* watchFetchPreference() {
  yield takeLatest(RequestTypes.GET_PREFERENCE_REQUEST, fetchPreferenceSaga);
}
